/**
 * Main
 *
 * Copyright (c) 2020 Aperia Company
 * Released under the MIT license
 */
//  export js
"use strict";

window.app = app;
$(function () {
  new app.Core();
  new app.Sticky();
  new app.Menu();
  new app.Custom();

  new app.Slider({
    el: "#main-slider",
    options: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      // fade: true,
      autoplay: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#partner-slider",
    options: {
      slidesToShow: 7,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#productNew-slider",
    options: {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#product-slider",
    options: {
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#product-slider-sub",
    options: {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    }
  });
  new app.SliderThumbnail({
    // el: "#product-single-slider",
    elParent: "#product-single-slider",
    elChild: "#product-single-thumb",
    optionParent: {
      // arrows: true
      arrows: false,
      // fade: true,
      // dots: false,
      autoplay: false,
      autoplaySpeed: 2000,
      pauseOnHover: false
    },
    optionChild: {
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      vertical: true,
      adaptiveHeight: true,
      verticalSwiping: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            vertical: false,
            adaptiveHeight: false,
            verticalSwiping: false
          }
        }
      ]
    }
  });
});
